import React, { useRef } from 'react';
import { ADVANCE_VIEWER_BASE_URL } from '../../../../constants/Constants';
import { useMedDreamActiveStudy } from '../../helpers/MedDreamIntegration';

const IframeViewer = (props) => {

  // const [url,setUrl] = useState(import.meta.env.VITE_ADVANCEVIEWER_BASE_URL + "?study=" + window.location.pathname.substring(
  //   window.location.pathname.lastIndexOf("/") + 1
  // ));

  const iframeRef = useRef(null);

  // Tells the app which study sits in the viewer's focused viewport, so the report panel
  // can follow the radiologist between the reported study and its priors.
  useMedDreamActiveStudy({
    iframeRef,
    viewerUrl: props.meddreamFullUrl,
    studyInstanceUidMap: props.studyInstanceUidMap,
    onActiveStudyChange: props.onActiveStudyChange,
  });

  return (
    <>
      <iframe
        ref={iframeRef}
        title="Meddream Viewer"
        width="100%"
        height="100%"
        src={props.meddreamFullUrl}
        allow="clipboard-read; clipboard-write; fullscreen"
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </>
  );
};

export default IframeViewer;
